<template>
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageaddheader :title="title" :title1="title1" :items="canManagePeople ? items : null" />
        <div class="card">
          <div class="card-body">
            <div class="table-top">
              <div class="search-set">
                <div class="search-path">
                  <a
                    class="btn btn-filter"
                    id="filter_search"
                    v-on:click="filter = !filter; this.search=''"
                    :class="{ setclose: filter }"
                  >
                    <img src="../../../assets/img/icons/filter.svg" alt="img" />
                    <span><img src="../../../assets/img/icons/closes.svg" alt="img" /></span>
                  </a>
                </div>
                <div class="search-input">
                  <a class="btn btn-searchset"><img src="../../../assets/img/icons/search-white.svg" alt="img" /></a>
                  <div class="dataTables_filter">
                    <label>
                      <input
                        type="search"
                        v-model="search"
                        class="form-control form-control-sm"
                        placeholder="Search..."
                        @change="searching"
                      />
                    </label>
                  </div>
                </div>
              </div>
              <div class="search-path">
                <div class="form-group mb-0 dealer-branch-filter">
                  <select class="form-control" v-model="selectedBranch">
                    <option value="">All Branches</option>
                    <option
                      v-for="branch in branches"
                      :key="branch.branchid"
                      :value="branch.branchid"
                    >
                      {{ branch.branchname }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <a-table :columns="columns" :data-source="filteredItems">
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'dealerid'">
                    <div class="productimgname">
                      <a href="javascript:void(0);">{{ record.dealername }}</a>
                    </div>
                  </template>
                  <template v-else-if="column.key === 'branches'">
                    {{ (record.branchnames || []).join(', ') }}
                  </template>
                  <template v-else-if="column.key === 'action' && canManagePeople">
                    <a class="me-3" @click="editdealer(record)" href="javascript:void(0);">
                      <img src="../../../assets/img/icons/edit.svg" alt="img" />
                    </a>
                    <a class="me-3 confirm-text" href="javascript:void(0);" @click="showAlert(record.dealerid)">
                      <img src="../../../assets/img/icons/delete.svg" alt="img" />
                    </a>
                  </template>
                </template>
              </a-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed, toRefs } from 'vue';
import { useAuthenticator } from '@aws-amplify/ui-vue';

const { user } = toRefs(useAuthenticator());
const canManagePeople = computed(() => user.value?.attributes?.['custom:role'] === 'Admin');
</script>
<script>
import axios from "axios";

const columns = [
  {
    sorter: true,
  },
  {
    title: "Dealer Name",
    dataIndex: "dealername",
    key: "dealerid",
    sorter: {
      compare: (a, b) => a.dealername.toLowerCase() > b.dealername.toLowerCase() ? -1 : 1,
    },
  },
  {
    title: "Contact Person",
    dataIndex: "contactperson",
    sorter: {
      compare: (a, b) => (a.contactperson || '').toLowerCase() > (b.contactperson || '').toLowerCase() ? -1 : 1,
    },
  },
  {
    title: "Phone",
    dataIndex: "phone",
    sorter: {
      compare: (a, b) => (a.phone || 0) > (b.phone || 0) ? -1 : 1,
    },
  },
  {
    title: "Email",
    dataIndex: "email",
    sorter: {
      compare: (a, b) => (a.email || '').toLowerCase() > (b.email || '').toLowerCase() ? -1 : 1,
    },
  },
  {
    title: "Address",
    dataIndex: "address",
    sorter: {
      compare: (a, b) => (a.address || '').toLowerCase() > (b.address || '').toLowerCase() ? -1 : 1,
    },
  },
  {
    title: "Branches",
    key: "branches",
    sorter: {
      compare: (a, b) => (a.branchnames || []).join(',').toLowerCase() > (b.branchnames || []).join(',').toLowerCase() ? -1 : 1,
    },
  },
  {
    title: "Remarks",
    dataIndex: "remarks",
    sorter: {
      compare: (a, b) => (a.remarks || '').toLowerCase() > (b.remarks || '').toLowerCase() ? -1 : 1,
    },
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';
axios.defaults.headers.common['api-key'] = process.env.VUE_APP_API_KEY;

export default {
  data() {
    return {
      filter: false,
      search: '',
      selectedBranch: '',
      title: "Dealer List",
      title1: "Manage your dealers",
      items: [
        {
          text: "Add Dealer",
          addname: "/adddealer",
        },
      ],
      data: [],
      branches: [],
      columns,
    };
  },
  methods: {
    handleKeydown(event) {
      if (this.$route.path === '/dealerlist' && event.ctrlKey && (event.key === 'm' || event.key === 'M')) {
        event.preventDefault();
        this.$router.push('/adddealer');
      }
    },
    searching() {
      if (this.search) this.filter = true;
    },
    showAlert(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        showCancelButton: true,
        confirmButtonColor: "#FF9F43",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .delete('/v1/dealers/' + id)
            .then(() => {
              Swal.fire("Deleted!", "Dealer has been deleted.");
              const index = this.data.findIndex(function(o) {
                return o.dealerid === id;
              });
              if (index !== -1) this.data.splice(index, 1);
            })
            .catch(error => {
              console.log(error);
              Swal.fire(error.response.data.detail);
            });
        }
      });
    },
    editdealer(dealer) {
      this.$router.push({ path: '/editdealer', query: { id: dealer.dealerid } });
    },
    async getDealers() {
      axios
        .get('/v1/dealers')
        .then(response => {
          this.data = response.data;
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        });
    },
    async getBranches() {
      axios
        .get('/v1/branches')
        .then(response => {
          this.branches = response.data;
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        });
    }
  },
  computed: {
    filteredItems() {
      return this.data ? this.data.filter(item => {
        const dealerName = (item.dealername || '').toLowerCase();
        const address = (item.address || '').toLowerCase();
        const branches = (item.branchnames || []).join(' ').toLowerCase();
        const query = this.search.toLowerCase();
        const matchesSearch = !this.search || dealerName.includes(query) || address.includes(query) || branches.includes(query);
        const matchesBranch = !this.selectedBranch || (item.branchids || []).includes(this.selectedBranch);
        return matchesSearch && matchesBranch;
      }) : null;
    },
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
  beforeMount() {
    this.getDealers();
    this.getBranches();
  },
  name: "dealerlist",
};
</script>
<style scoped>
.dealer-branch-filter {
  min-width: 220px;
}

.dealer-branch-filter select {
  min-height: 40px;
}
</style>
